import { Model as c } from "../../../../../model.js";
class n extends c {
  constructor(o) {
    super(), this.configuration = o.configuration, this.account = o.account;
  }
}
export {
  n as ShopSessionCashbackModel
};
//# sourceMappingURL=shopSessionCashback.model.js.map
